import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
export var GLOBAL_SHARE_CONFIG_KEY = "spiral-app-global-share-config";
/** 由主应用分发的全局配置，只能由主应用设置 */
export var setGlobalShareConfig = function setGlobalShareConfig(config) {
  if (window.__MICRO_APP_ENVIRONMENT__) {
    return;
  }
  try {
    var cacheConfig = JSON.parse(window.localStorage.getItem(GLOBAL_SHARE_CONFIG_KEY) || "{}");
    window.localStorage.setItem(GLOBAL_SHARE_CONFIG_KEY, JSON.stringify(_objectSpread(_objectSpread({}, cacheConfig), config)));
  } catch (error) {
    console.warn(error);
    window.localStorage.setItem(GLOBAL_SHARE_CONFIG_KEY, JSON.stringify(_objectSpread({}, config)));
  }
};

/** 初始化就固定的全局配置 */
export var getGlobalShareConfigValueByKey = function getGlobalShareConfigValueByKey(key) {
  try {
    var cacheConfig = window.localStorage.getItem(GLOBAL_SHARE_CONFIG_KEY) || "{}";
    return JSON.parse(cacheConfig)[key];
  } catch (error) {
    return null;
  }
};